import React from 'react'
import { IIconProps as IProps } from './IIconProps'

const IconCalendar = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M2.542 1.22a.57.57 0 0 1-.57.57H1.48a.57.57 0 0 0-.57.57v8.524c0 .316.255.571.57.571h9.117a.57.57 0 0 0 .57-.57V2.36a.57.57 0 0 0-.57-.57h-.674a.57.57 0 0 1-.57-.57v-.127a.547.547 0 0 0-1.095 0v.126a.57.57 0 0 1-.57.57H4.206a.57.57 0 0 1-.57-.57v-.126a.547.547 0 0 0-1.095 0v.126Zm-.31 1.664a.228.228 0 0 0-.228.229v.878c0 .126.102.229.228.229h7.613a.228.228 0 0 0 .228-.229v-.878a.228.228 0 0 0-.228-.229H2.232Zm7.841 2.477a.228.228 0 0 0-.228-.229H2.232a.228.228 0 0 0-.228.229V9.79c0 .315.255.57.57.57h6.929a.57.57 0 0 0 .57-.57V5.36Z"
      clipRule="evenodd"
    />
  </svg>
)

export default IconCalendar
